/**
 |-----------------------------------------------------------------------------
 | vendor/headroom.js
 | v1.0.0
 |-----------------------------------------------------------------------------
 |
 | Some description...
 |
 */

/*
 |
 | Some description...
 |
 */

const Headroom = require('headroom.js');





/*
 |
 | Some description...
 |
 */

const header   = document.querySelector('.l-site-header');

if ($('html').hasClass('touchevents')) {

	const headroom = new Headroom(header, {

		// Initialisation
		offset    : 1,
		tolerance : {
			down : 0,
			up   : 0
		},

	});
	headroom.init();

} else {

	const logo = $('.l-site-header .o-logo img').attr('src');
	const url  = $('.l-site-header .o-logo').attr('href');

	const headroom = new Headroom(header, {

		// Initialisation
		offset    : 1,
		tolerance : {
			down : 0,
			up   : 0
		},

		// Callbacks
		onPin : function() {
			$('.l-site-header .o-logo img').attr('src', url + 'assets/images/lgo_hamiltonRose_whiteout.svg');
		},

		onTop : function() {
			$('.l-site-header .o-logo img').attr('src', logo);
		}

	});
	headroom.init();

}
